import React from 'react';
import { Loading } from '@lion-design/core';
import cN from 'classnames';
import styles from './styles.module.scss';

const Spinner = (props: { size?: 'sm' | 'md' | 'lg' }) => {
    return (
        <div className={cN(styles.spinner, 'spinner')}>
            <Loading theme="dot-circle" visible={true} size={props.size} />
        </div>
    );
};

export default Spinner;
